exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".custom-checkbox .custom-control-input:checked~.custom-control-label:before{background-color:#0091ff!important}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/menu/AvailableForm.vue"],"names":[],"mappings":"AACA,4EACE,kCAAqC,CACtC","file":"AvailableForm.vue","sourcesContent":["\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #0091ff !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-def541b0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/menu/AvailableForm.vue
// module id = 1547
// module chunks = 0